import toast from "react-hot-toast";
import { useSupabaseCallback, useSupabaseLoader } from "../../../server/supabase/hooks";
import type { HrisConfig } from "../../integrations/server/supabase-hris-service";
import {
  SupabaseHRISService,
  SupabaseSuperAdminHRISService,
} from "../../integrations/server/supabase-hris-service";

export const useHrisIntegration = (): ReturnType<typeof useSupabaseLoader<HrisConfig | null>> & {
  disableIntegration: () => Promise<void>;
} => {
  const result = useSupabaseLoader(async ({ supabase }) => {
    const { data } = await new SupabaseHRISService(supabase).maybeGet();
    return data;
  }, []);

  const disconnectHRIS = useSupabaseCallback(
    async ({ supabase }) => {
      await new SupabaseSuperAdminHRISService(supabase).disconnect();
    },
    [],
    "super_admin",
  );

  const { reload } = result;

  const disableIntegration = useSupabaseCallback(
    async ({ supabase }) => {
      await disconnectHRIS();

      const error = await new SupabaseHRISService(supabase).delete();

      if (!error) {
        reload();
        toast.success("HRIS successfully disconnected");
      } else {
        toast.error("There was an error disconnecting your HRIS, please contact support.");
      }
    },
    [disconnectHRIS, reload],
  );

  return { ...result, disableIntegration };
};
